import { render, staticRenderFns } from "./GenomicSamples.vue?vue&type=template&id=c5cd1920"
import script from "./GenomicSamples.vue?vue&type=script&lang=js"
export * from "./GenomicSamples.vue?vue&type=script&lang=js"
import style0 from "./GenomicSamples.vue?vue&type=style&index=0&id=c5cd1920&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports